import {
	IonButton,
	IonButtons,
	IonCard,
	IonCardContent,
	IonCol,
	IonContent,
	IonGrid,
	IonHeader,
	IonIcon,
	IonInput,
	IonItem,
	IonItemDivider,
	IonLabel,
	IonList,
	IonModal,
	IonPage,
	IonRange,
	IonRow,
	IonSelect,
	IonSelectOption,
	IonTitle,
	IonToggle,
	IonToolbar,
	isPlatform,
} from "@ionic/react";
import { ref, update } from "firebase/database";
import {
	add,
	chevronBack,
	chevronDownOutline,
	chevronForward,
	chevronForwardOutline,
	closeOutline,
	ear,
	globeOutline,
	helpCircleOutline,
	remove,
	removeCircleOutline,
	settings as settingsIcon,
	textOutline,
} from "ionicons/icons";
import React from "react";
import { isAndroid, isIOS, isMobile, isTablet } from "react-device-detect";
import { Trans } from "react-i18next";
import Joyride from "react-joyride";
import { connect } from "react-redux";
import { appVersion } from "../../../appVersion";
import { sendEvent } from "../../../common/amplitudeUtils";
import { fromQueryToObjOfParams } from "../../../common/queryUtils";
import { handleJoyrideCallback, Step, updateChoice } from "../../../common/utilsJoyride";
import { auth, database } from "../../../firebaseConfig";
import i18n from "../../../i18n";
import { loadPaywall } from "../../../loadPaywall";
import { setTheme, themes } from "../../../theme/theme";
import MenuTabBar from "../../menu/MenuTabBar";
import { TTSSettings } from "../../tts/store/reducers";
import { ttsServices } from "../../tts/store/services";
import "../../user/pages/Profile.css";
import { Organization } from "../../user/store/reducers";
import { Coloring, DocumentFontSettings, Highlight, settingsServices, UserSettings } from "../store/services";
import "./Settings.css";
import { hslToHex, saveColor, updateColor } from "./utilsColorPickerModal"; // Adjust the import path as needed
import { checkStatusBar } from "../../sessions/utils/utils";
import reasyLogoBook from "../../../assets/icons/reasy_logo_book.svg";

type Props = {
	history: any;
	settings: any;
	orgData: Organization | null;
};

type State = {
	highlightings: Highlight[];
	colorings: Coloring[];
	isHighlightingActive: boolean;
	documentFontSettings: DocumentFontSettings | null;
	userSettings: UserSettings | null;
	ttsSettings: UserSettings | null;
	text: boolean;
	bearerToken: string;

	highlightTargetText: string;
	showColorPicker: boolean;
	pickedColor: string;

	preferredPalette: string;
	///
	userUuid: string;

	showModalLanguage: boolean;
	paywallState: boolean;
	isColorPickerOpen: boolean;
	hue: number;
	saturation: number;
	brightness: number;
	previewColor: string;
	savedColors: string[];
	recentColors: string[];

	steps: Step[];
	tutorial: boolean;
	stepIndex: number;
	isLoading:boolean;
};

class Settings extends React.Component<Props, State> {
	constructor(props: any) {
		super(props);
		this.state = {
			highlightings: [],
			colorings: [],
			userSettings: null,
			isHighlightingActive: false,
			documentFontSettings: null,
			ttsSettings: null,

			highlightTargetText: "",
			showColorPicker: false,
			pickedColor: "#0079BF",

			preferredPalette: "",
			text: true,
			bearerToken: "",
			///
			userUuid: "",

			showModalLanguage: false,
			paywallState: false,
			isColorPickerOpen: false,
			hue: 0,
			saturation: 100,
			brightness: 50,
			previewColor: "#808080",
			savedColors: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff"],
			recentColors: ["#fff", "#fff", "#fff", "#fff", "#fff", "#fff"],

			steps: [
				{
					target: ".fontSection",
					content: (
						<div>
							<p className="tutorial-txt">
								<Trans>Scegli il tipo di font, la sua dimensione e l'interlinea del testo</Trans>
							</p>
						</div>
					),
					disableBeacon: true,
					disableScrollParentFix: true,
					placement: "auto",
				},
				{
					target: ".highlightSection",
					content: (
						<div>
							<p>
								<Trans>Personalizza i colori di lettere o parole specifiche nel testo</Trans>
							</p>
							{/* <video className='tutorialVideo' autoPlay controls controlsList="nodownload">
								<source
									src="https://reasy-public-tutorials.s3.eu-south-1.amazonaws.com/v1.7.5/6.+Colorazione+lettere_parole.mp4"
									type="video/mp4"
								/>
								Your browser does not support the video tag.
							</video> */}
						</div>
					),
					disableBeacon: true,
					placement: "auto",
				},
				{
					target: ".previewSection",
					content: (
						<div>
							<p>
								<Trans>Guarda l'anteprima delle configurazioni che hai scelto</Trans>
							</p>
						</div>
					),
					disableBeacon: true,
					placement: "auto",
				},
				{
					target: ".ttsSection",
					content: (
						<div>
							<p>
								<Trans>Scegli la velocità e il tipo di voce della sintesi vocale</Trans>
							</p>
						</div>
					),
					disableBeacon: true,
					placement: "auto",
				},
				{
					target: ".colorChange",
					content: (
						<div>
							<p>
								<Trans>Cambia i colori dello sfondo di Reasy</Trans>
							</p>
						</div>
					),
					disableBeacon: true,
					placement: "auto",
				},
			],
			tutorial: false,
			stepIndex: 0,
			isLoading:false,
		};
	}

componentDidMount() {
  this.setState({ isLoading: true });

  const authPromise = new Promise<void>((resolve) => {
    const unsubscribe = auth.onAuthStateChanged(async (userData) => {
      if (userData) {
        try {
          const token = await userData.getIdToken();
          this.setState({ 
            bearerToken: token,
            userUuid: userData.uid 
          });

          // Fetch all settings in parallel
          const [colorings, documentViewingSettings, preferredTheme, userSettings] = await Promise.allSettled([
            settingsServices.getColourings(userData.uid, token),
            settingsServices.getDocumentViewingSettings(userData.uid),
            settingsServices.getPreferredTheme(userData.uid, token),
            settingsServices.getUserSettings(userData.uid, token)
          ]);

          // Handle colorings
          if (colorings.status === 'fulfilled') {
            console.log(colorings.value);
            this.setState({ colorings: colorings.value });
          } else {
            console.error("[Settings] error getting highlightings:", colorings.reason);
          }

          // Handle document viewing settings
          if (documentViewingSettings.status === 'fulfilled') {
            this.setState({ documentFontSettings: documentViewingSettings.value });
          } else {
            console.error("[Settings] error getting viewing settings", documentViewingSettings.reason);
          }

          // Handle preferred theme
          if (preferredTheme.status === 'fulfilled') {
            this.setState({ 
              preferredPalette: preferredTheme.value.theme ? preferredTheme.value.theme : "default" 
            });
          }

          // Handle user settings
          if (userSettings.status === 'fulfilled') {
            console.log(userSettings.value);
            this.setState({
              userSettings: userSettings.value,
              ttsSettings: {
                speech_rate: userSettings.value.speech_rate,
                speech_gender: userSettings.value.speech_gender ? "F" : "M",
              },
            });
          } else {
            console.error("[Settings] error getting viewing settings", userSettings.reason);
          }

        } catch (error) {
          console.error("Error in auth state change:", error);
        }
      } else {
        this.setState({ userUuid: "" });
      }
      
      unsubscribe();
      resolve();
    });
  });

  // Wait for auth to complete
  authPromise.finally(() => {
    this.setState({ isLoading: false });
    
    // Handle query parameters after loading
    if (this.props.history.location.search !== "") {
      const ltm = fromQueryToObjOfParams(this.props.history.location.search as string)["ltm"];
      this.setState({
        highlightTargetText: ltm,
      });
      const inputElement = document.getElementById("lettersToMarkInput") as HTMLIonInputElement | null;
      inputElement?.focus();
    }
  });
}

	convertTtsSpeed(speed: number | undefined) {
		if (speed === 0.75) return "slow";
		else if (speed === 1) return "medium";
		else if (speed === 1.5) return "fast";
		else return "medium";
	}

	playAudio() {
		let gender = this.state.ttsSettings?.speech_gender === "female" ? "Female" : "Male";
		let prosody_rate = this.state.ttsSettings?.speech_rate === 0.75 ? "Slow" : this.state.ttsSettings?.speech_rate === 1 ? "Medium" : "Fast";
		let language =
			i18n.language === "en"
				? "EN"
				: i18n.language === "fr"
				? "FR"
				: i18n.language === "es"
				? "ES"
				: i18n.language === "de"
				? "DE"
				: i18n.language === "ca"
				? "ES"
				: "IT";
		let src = require("../../../assets/speech-samples/" + gender + prosody_rate + language + ".mp3");
		let audio = new Audio(src);
		audio.play();
	}

	getNextFontOption(direction: "right" | "left") {
		let font_list: any = ["open_dyslexic", "arial", "verdana", "georgia", "tahoma"];
		let currentFont = this.state.userSettings?.font_name;
		if (currentFont) {
			let currentFontIndex = font_list.indexOf(currentFont);
			if (direction === "right") {
				if (currentFontIndex === 4) {
					return font_list[0];
				} else return font_list[currentFontIndex + 1];
			} else {
				if (currentFontIndex === 0) {
					return font_list[4];
				} else return font_list[currentFontIndex - 1];
			}
		}
	}

	handleFocusInput = () => {
		// Assuming you want to modify the CSS custom property of the IonInput or its container
		document.getElementById("lettersToMarkInput")?.style.setProperty("--highlight-color-focused", this.state.pickedColor);
	};
	saveFontSize = (newValue: number) => {
		settingsServices
			.setFontSize(this.state.userUuid, newValue, this.state.bearerToken)
			.then((userSettings) => {
				//console.log('[Settings] editing font size success', documentViewingSettings);
				this.setState({ userSettings: userSettings });
			})
			.catch((err) => {
				//console.log('[Settings] error editing font size:', err);
			});
	};

	saveLineSpacing = (newValue: number) => {
		settingsServices
			.setLineHeight(this.state.userUuid, newValue, this.state.bearerToken)
			.then((userSettings) => {
				//console.log('[Settings] editing line leading success', documentViewingSettings);
				this.setState({ userSettings: userSettings });
			})
			.catch((err) => {
				console.error("[Settings] error editing line leading:", err);
			});
	};
	changeAppLanguage(lang: string) {
		i18n.changeLanguage(lang);
		if (this.state.userUuid) {
			update(ref(database, `u/${this.state.userUuid}`), {
				l: lang,
			})
				.then(() => {
					window.location.reload();
				})
				.catch((err) => {
					console.error("[Profile] error updating user language:", err);
				});
		}
	}
	ColoredPreviewTextJSX: React.FC<{ colorings: any[]; textKey?: string; defaultText?: string }> = ({
		colorings,
		textKey = "Stai visualizzando le modifiche del testo che hai scelto. Con Reasy il tuo apprendimento diventa accessibile e personalizzabile.",
		defaultText = "Stai visualizzando le modifiche del testo che hai scelto. Con Reasy il tuo apprendimento diventa accessibile e personalizzabile.",
	}) => {
		// Get translated text
		const text = i18n.t(textKey, { message: defaultText });

		const getColoredElements = () => {
			if (!colorings || colorings.length === 0) {
				return text;
			}

			// Create a map of all positions that need coloring
			const colorMap = new Map<number, { color: string; pattern: string }>();

			colorings.forEach((coloring) => {
				const pattern = coloring.text_pattern;
				const color = coloring.color.replace(/[`'"]/g, "");
				const regex = new RegExp(pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");

				let match;
				while ((match = regex.exec(text)) !== null) {
					for (let i = 0; i < match[0].length; i++) {
						colorMap.set(match.index + i, { color, pattern });
					}
				}
			});

			// Build JSX elements
			const elements: JSX.Element[] = [];
			let currentSpan = "";
			let currentColor = "";

			for (let i = 0; i < text.length; i++) {
				const charColor = colorMap.get(i);

				if (charColor && charColor.color !== currentColor) {
					// Push previous span if exists
					if (currentSpan) {
						elements.push(
							currentColor ? (
								<span key={`span-${i}-prev`} style={{ color: currentColor }}>
									{currentSpan}
								</span>
							) : (
								<span key={`span-${i}-prev`}>{currentSpan}</span>
							)
						);
					}
					currentSpan = text[i];
					currentColor = charColor.color;
				} else if (!charColor && currentColor) {
					// End of colored section
					elements.push(
						<span key={`span-${i}-colored`} style={{ color: currentColor }}>
							{currentSpan}
						</span>
					);
					currentSpan = text[i];
					currentColor = "";
				} else {
					currentSpan += text[i];
				}
			}

			// Push final span
			if (currentSpan) {
				elements.push(
					currentColor ? (
						<span key="span-final" style={{ color: currentColor }}>
							{currentSpan}
						</span>
					) : (
						<span key="span-final">{currentSpan}</span>
					)
				);
			}

			return elements;
		};

		return <>{getColoredElements()}</>;
	};
	render() {
		return (
			<IonPage id="settingsPage" className="settingsMainPage">
				<IonIcon hidden={!this.state.isLoading} className="bigBookLoader fill-icon" src={reasyLogoBook}></IonIcon>

				<Joyride
					steps={this.state.steps}
					run={this.state.tutorial} // Set to true to start the tour automatically
					continuous={true} // Allow continuous navigation through the tour
					showProgress={true} // Display progress indicator
					showSkipButton={true} // Display skip button
					spotlightClicks={true}
					callback={(data) => handleJoyrideCallback.call(this, data, "Settings")}
					hideBackButton={false}
					locale={{
						skip: (
							<div
								className="skip"
								onClick={() => {
									updateChoice.call(this, "tutorialSettings");
								}}
							>
								<Trans>Salta</Trans>
							</div>
						),
						back: (
							<div className="nextTutorialBtn">
								<Trans>Precedente</Trans>
							</div>
						),
						next: (
							<span>
								<Trans>Avanti</Trans>
							</span>
						),
						last: (
							<div
								className="nextTutorialBtn"
								onClick={() => {
									updateChoice.call(this, "tutorialSettings");
								}}
							>
								<Trans>Ultimo</Trans>
							</div>
						),
					}}
					styles={{
						buttonNext: {
							fontSize: "12px",
							outline: "none",
						},
						tooltip: {
							backgroundColor: "var(--bg-content-color)", // Tooltip background
						},
					}}
				/>

				{isMobile && !this.state.text && (
					<IonGrid class="gridTablet">
						<IonCard className="cardBgTablet">
							<IonCardContent>
								<div>
									<IonItem
										onClick={() => {
											this.setState({ showModalLanguage: true });
										}}
										className="itemSettingsTablet"
										lines="none"
									>
										<IonLabel className="labelSettingsTablet">
											<IonIcon className="iconSettingsTablet" slot="start" icon={globeOutline}></IonIcon>
											<Trans>Lingue</Trans>
										</IonLabel>

										<IonLabel className="fontstyle" style={{ textAlign: "right" }}>
											{i18n.language === "it"
												? "Italiano"
												: i18n.language === "en"
												? "English"
												: i18n.language === "fr"
												? "Français"
												: i18n.language === "es"
												? "Español"
												: i18n.language === "ca"
												? "Català"
												: i18n.language === "de"
												? "Deutsch"
												: i18n.language === "nl"
												? "Olandese"
												: "Czech"}
										</IonLabel>
										<IonIcon className="iconSettingsTablet" slot="end" icon={chevronDownOutline}></IonIcon>
									</IonItem>

									<IonModal
										isOpen={this.state.showModalLanguage}
										onDidDismiss={() => this.setState({ showModalLanguage: false })}
										className="settingsModalLanguageTablet"
									>
										<IonItem lines="none" className="modalTitle">
											<IonLabel className="settingsModalDescriptionTablet">
												<Trans>Seleziona una lingua</Trans>
											</IonLabel>
										</IonItem>
										<IonIcon
											className="settingsModalDescriptionIconTablet"
											icon={closeOutline}
											onClick={() => {
												this.setState({ showModalLanguage: false });
											}}
										></IonIcon>

										<div className="settingsModalLanguagesSelectionTablet">
											<IonItem
												onClick={() => {
													this.changeAppLanguage("it");
												}}
												className="settingsModalLanguagesItemTablet"
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">Italiano</IonLabel>
											</IonItem>

											<IonItem
												className="settingsModalLanguagesItemTablet"
												onClick={() => {
													this.changeAppLanguage("en");
												}}
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">English</IonLabel>
											</IonItem>

											<IonItem
												className="settingsModalLanguagesItemTablet"
												onClick={() => {
													this.changeAppLanguage("fr");
												}}
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">Français</IonLabel>
											</IonItem>

											<IonItem
												className="settingsModalLanguagesItemTablet"
												onClick={() => {
													this.changeAppLanguage("es");
												}}
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">Español</IonLabel>
											</IonItem>

											<IonItem
												className="settingsModalLanguagesItemTablet"
												onClick={() => {
													this.changeAppLanguage("ca");
												}}
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">Català</IonLabel>
											</IonItem>
											<IonItem
												className="settingsModalLanguagesItemTablet"
												onClick={() => {
													this.changeAppLanguage("de");
												}}
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">Deutsch</IonLabel>
											</IonItem>
											<IonItem
												className="settingsModalLanguagesItemTablet"
												onClick={() => {
													this.changeAppLanguage("nl");
												}}
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">Olandese</IonLabel>
											</IonItem>
											<IonItem
												className="settingsModalLanguagesItemTablet"
												lines="none"
												style={{ "--inner-border-width": "0px" }}
												onClick={() => {
													this.changeAppLanguage("cz");
												}}
											>
												<IonLabel className="settingsModalLanguagesLabelTablet">Czech</IonLabel>
											</IonItem>
										</div>
									</IonModal>

									<IonItem
										className="itemSettingsTablet"
										style={{ marginTop: "20px" }}
										onClick={() => {
											this.setState({ text: true });
											// setTimeout(() => {
											// 	settingsServices.getUserTutorialChoice(this.state.userUuid, "tS").then((response) => {
											// 		this.setState({ tutorial: response }, () => {
											// 			if (response === true)
											// 				sendEvent({
											// 					"user_id": this.state.userUuid,
											// 					"event_type": "Tutorial showed",
											// 					"event_properties": {
											// 						"user_org": this.props.orgData !== null ? this.props.orgData.name : 'Private User',
											// 						"page": "Settings"
											// 					},
											// 					"language": i18n.language,
											// 					"platform": isPlatform('ios') ? 'ios' : isPlatform('android') ? 'android' : 'desktop',
											// 					"app_version": appVersion,
											// 					"time": Date.now()
											// 				})
											// 		});
											// 	});
											// }, 1000);
										}}
									>
										<IonLabel className="labelSettingsTablet">
											<IonIcon className="iconSettingsTablet" slot="start" icon={textOutline}></IonIcon>
											<Trans>Testi</Trans>
										</IonLabel>
										<IonIcon className="iconSettingsTablet" slot="end" icon={chevronForwardOutline}></IonIcon>
									</IonItem>
								</div>
							</IonCardContent>
						</IonCard>
					</IonGrid>
				)}
				{!this.state.isLoading && (
					<>
						{" "}

						<div className="settingsHeaderDiv">
						{isMobile && <IonToolbar className="toolbarNotchSettings" style={{ height: checkStatusBar() }}></IonToolbar>}
<div className="settingsHeaderContent">
							<IonButtons
								slot="start"
								onClick={() => {
									this.props.history.push("/sessions");
								}}
							>
								<IonIcon className="back-btn-icon-settings" icon={chevronBack} />
							</IonButtons>
							<IonTitle className="settingsHeader">
								<Trans>Configurazioni</Trans>
							</IonTitle>

							<IonIcon
								slot="end"
								className="settingsHelpIcon"
								style={{ fontSize: "45px" }}
								onClick={(e) => {
									this.setState({ tutorial: true }, () => {
										sendEvent({
											"user_id": this.state.userUuid,
											"event_type": "Tutorial opened",
											"event_properties": {
												"user_org": this.props.orgData !== null ? this.props.orgData.name : "Private User",
												"page": "Settings",
											},
											"language": i18n.language,
											"platform": isIOS ? "ios" : isAndroid ? "android" : "desktop",
											"app_version": appVersion,
											"time": Date.now(),
										});
									});
								}}
								icon={helpCircleOutline}
							></IonIcon>
							</div>
						</div>
						<IonGrid className="settingsGrid">
							<div className="settingsCard fontSection">
								<p className="settingsSectionParagraph">
									<Trans>Configurazioni font</Trans>
								</p>
								<IonCardContent mode="ios" className="fontCard">
									<IonList className="cardWrap" mode="ios">
										<IonItem className="settingsDocumentViewingItem" lines="none">
											<div className="settingsDocumentViewingItemDiv">
												<div className="settingsFontDiv">
													<IonIcon
														className="settingsFontArrowButton"
														onClick={() => {
															let fromButton = true;
															if (this.state.paywallState) loadPaywall(fromButton);
															else if (this.state.userUuid) {
																let fontToSet = this.getNextFontOption("left");
																settingsServices
																	.setFontType(this.state.userUuid, fontToSet, this.state.bearerToken)
																	.then((userSettings) => {
																		this.setState({ userSettings: userSettings });
																	})
																	.catch((err) => {
																		console.error("[Settings] Error changing font:", err);
																	});
															}
														}}
														size="large"
														slot="start"
														icon={chevronBack}
													/>
													<p hidden={this.state.userSettings?.font_name?.toLowerCase() !== "open_dyslexic"}>OpenDyslexic</p>
													{/* <p hidden={this.state.documentFontSettings?.font !== "easy_reading"}>EasyReading</p> */}
													<p hidden={this.state.userSettings?.font_name?.toLowerCase() !== "arial"}>Arial</p>
													<p hidden={this.state.userSettings?.font_name?.toLowerCase() !== "verdana"}>Verdana</p>
													<p hidden={this.state.userSettings?.font_name?.toLowerCase() !== "georgia"}>Georgia</p>
													<p hidden={this.state.userSettings?.font_name?.toLowerCase() !== "tahoma"}>Tahoma</p>
													<IonIcon
														className="settingsFontArrowButton"
														onClick={() => {
															let fromButton = true;
															if (this.state.paywallState) loadPaywall(fromButton);
															else if (this.state.userUuid) {
																let fontToSet = this.getNextFontOption("right");
																console.log(fontToSet);
																settingsServices
																	.setFontType(this.state.userUuid, fontToSet, this.state.bearerToken)
																	.then((userSettings) => {
																		this.setState({ userSettings: userSettings });
																	})
																	.catch((err) => {
																		console.error("[Settings] Error changing font:", err);
																	});
															}
														}}
														size="large"
														slot="end"
														icon={chevronForward}
													/>
												</div>
											</div>
										</IonItem>

										<IonItem className="settingsDocumentViewingItem" lines="none" style={{ zIndex: -1000 }}>
											<div className="settingsDocumentViewingItemDiv">
												<p className="settingsDocumentViewingParagraph">
													<Trans>Dimensione font</Trans>
												</p>
												<div className="settingsFontSizeInputContainer">
													<IonInput
														className="settingsFontSizeInput"
														type="number"
														min={10}
														max={30}
														value={this.state.userSettings?.font_size}
														placeholder="Font size"
														onIonInput={(e) => {
															const newValue = Number(e.detail.value);
															if (newValue >= 10 && newValue <= 30) {
																this.setState(
																	(prevState) => ({
																		userSettings: {
																			...prevState.userSettings,
																			font_size: newValue,
																			font_name: prevState.userSettings?.font_name || "defaultFont",
																			line_height: prevState.userSettings?.line_height || 1.5,
																		},
																	}),
																	() => {
																		this.saveFontSize(newValue);
																	}
																);
															}
														}}
														onFocus={() => {
															let fromButton = true;
															if (this.state.paywallState) loadPaywall(fromButton);
														}}
													/>
													<span className="fontSizeUnit">px</span>
												</div>
												<div className="settingsDocumentViewingButtonsDiv">
													<div className="settingsDocumentViewingRangeDiv">
														<IonButton
															className="settingsDocumentViewingRangeButton"
															fill="clear"
															onClick={() => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
																else {
																	const fontSizeInput: HTMLIonRangeElement = document.getElementById("settingsFontSizeInput") as HTMLIonRangeElement;
																	if (fontSizeInput.value) {
																		// Convert the value to a number since it might be returned as a string
																		const newValue = Number(fontSizeInput.value) - 2;

																		// Ensure the new value is greater than 0 before attempting to update the state
																		if (newValue > 0) {
																			this.setState(
																				(prevState) => ({
																					userSettings: {
																						...prevState.userSettings,
																						font_size: newValue,
																						font_name: prevState.userSettings?.font_name || "defaultFont", // Fallback to 'defaultFont'
																						line_height: prevState.userSettings?.line_height || 1.5, // Fallback to 1.5
																					},
																				}),
																				() => {
																					this.saveFontSize(newValue);
																				}
																			);
																		}
																	}
																}
															}}
														>
															<IonIcon className="fontSizeIcons" size="large" icon={remove} />
														</IonButton>

														<IonRange
															id="settingsFontSizeInput"
															min={10}
															step={2}
															max={30}
															ticks={false}
															snaps
															value={this.state.userSettings?.font_size}
															debounce={300}
															onIonChange={(e) => {
																if (this.state.userSettings && this.state.userUuid) {
																	this.saveFontSize(Number(e.detail.value));
																}
															}}
															onClick={() => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
															}}
														/>

														<IonButton
															className="settingsDocumentViewingRangeButton"
															fill="clear"
															onClick={() => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
																else {
																	const fontSizeInput: HTMLIonRangeElement = document.getElementById("settingsFontSizeInput") as HTMLIonRangeElement;
																	if (fontSizeInput.value) {
																		// Convert the value to a number since it might be returned as a string
																		const newValue = Number(fontSizeInput.value) + 2;

																		// Ensure the new value is greater than 0 before attempting to update the state
																		if (newValue > 0) {
																			this.setState(
																				(prevState) => ({
																					userSettings: {
																						...prevState.userSettings,
																						font_size: newValue,
																						font_name: prevState.userSettings?.font_name || "defaultFont", // Fallback to 'defaultFont'
																						line_height: prevState.userSettings?.line_height || 1.5, // Fallback to 1.5
																					},
																				}),
																				() => {
																					this.saveFontSize(newValue);
																				}
																			);
																		}
																	}
																}
															}}
														>
															<IonIcon className="fontSizeIcons" size="large" icon={add} />
														</IonButton>
													</div>
												</div>
											</div>
										</IonItem>

										<IonItem className="settingsDocumentViewingItem" lines="none">
											<div className="settingsDocumentViewingItemDiv">
												<p className="settingsDocumentViewingParagraph">
													<Trans>Interlinea</Trans>
												</p>
												<div className="settingsFontSizeInputContainer">
													<IonInput
														className="settingsFontSizeInput"
														type="number"
														min={1}
														max={10}
														value={this.state.userSettings?.line_height}
														placeholder="Line Height"
														onIonInput={(e) => {
															const newValue = Number(e.detail.value);
															if (newValue >= 1 && newValue <= 10) {
																this.setState(
																	(prevState) => ({
																		userSettings: {
																			...prevState.userSettings,
																			font_size: prevState.userSettings?.font_size || 16,
																			font_name: prevState.userSettings?.font_name || "defaultFont",
																			line_height: newValue,
																		},
																	}),
																	() => {
																		this.saveLineSpacing(newValue);
																	}
																);
															}
														}}
														onFocus={() => {
															let fromButton = true;
															if (this.state.paywallState) loadPaywall(fromButton);
														}}
													/>
												</div>
												<div className="settingsDocumentViewingButtonsDiv">
													<div className="settingsDocumentViewingRangeDiv">
														<IonButton
															fill="clear"
															className="settingsDocumentViewingRangeButton"
															onClick={() => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
																else {
																	const lineLeadingInput: HTMLIonRangeElement = document.getElementById("settingsLineLeadingInput") as HTMLIonRangeElement;
																	if (lineLeadingInput.value && (lineLeadingInput.value as number) > 0) {
																		// lineLeadingInput.value = this.state.userSettings!.line_height - 5;
																		if (lineLeadingInput.value) {
																			// Convert the value to a number since it might be returned as a string
																			const newValue = Number(lineLeadingInput.value) - 1;

																			// Ensure the new value is greater than 0 before attempting to update the state
																			if (newValue > 0) {
																				this.setState(
																					(prevState) => ({
																						userSettings: {
																							...prevState.userSettings,
																							font_size: prevState.userSettings?.font_size || 16,
																							font_name: prevState.userSettings?.font_name || "defaultFont", // Fallback to 'defaultFont'
																							line_height: newValue, // Fallback to 1.5
																						},
																					}),
																					() => {
																						this.saveLineSpacing(newValue);
																					}
																				);
																			}
																		}
																	}
																}
															}}
														>
															<IonIcon size="large" className="fontSizeIcons" icon={remove} />
														</IonButton>
														<IonRange
															id="settingsLineLeadingInput"
															min={1}
															step={1}
															max={10}
															ticks={false}
															snaps
															value={this.state.userSettings?.line_height}
															debounce={300}
															onIonChange={(e) => {
																if (this.state.userSettings && this.state.userUuid) {
																	this.saveLineSpacing(Number(e.detail.value));
																}
															}}
															onClick={() => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
															}}
														/>

														<IonButton
															fill="clear"
															className="settingsDocumentViewingRangeButton"
															onClick={() => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
																else {
																	const lineLeadingInput: HTMLIonRangeElement = document.getElementById("settingsLineLeadingInput") as HTMLIonRangeElement;
																	if (lineLeadingInput.value && Number(lineLeadingInput.value) < 10) {
																		console.log("HEIGHT", lineLeadingInput.value);

																		// Convert the value to a number since it might be returned as a string
																		const newValue = Number(lineLeadingInput.value) + 1;

																		// Ensure the new value is greater than 0 before attempting to update the state
																		if (newValue >= 0) {
																			this.setState(
																				(prevState) => ({
																					userSettings: {
																						...prevState.userSettings,
																						font_size: prevState.userSettings?.font_size || 16,
																						font_name: prevState.userSettings?.font_name || "defaultFont", // Fallback to 'defaultFont'
																						line_height: newValue, // Fallback to 1.5
																					},
																				}),
																				() => {
																					this.saveLineSpacing(newValue);
																				}
																			);
																		}
																	}
																}
															}}
														>
															<IonIcon size="large" className="fontSizeIcons" icon={add} />
														</IonButton>
													</div>
												</div>
											</div>
										</IonItem>
									</IonList>
								</IonCardContent>
							</div>

							<div className="previewSection">
								<IonCard className="previewBox">
									<p className="settingsDocumentViewingPreviewHeaderParagraph">
										<Trans>Anteprima</Trans>
									</p>
									<div className="settingsDocumentViewingItemPreviewDiv">
										<p
											id="previewParagraph"
											className="settingsDocumentViewingPreviewParagraph"
											style={{
												fontFamily: settingsServices.fromBackendFontNameToCssFontFamily(
													this.state.userSettings && this.state.userSettings.font_name ? this.state.userSettings.font_name : "Arial"
												),
												fontSize: this.state.userSettings ? `${this.state.userSettings.font_size}px` : "30px",
												lineHeight: this.state.userSettings ? this.state.userSettings.line_height : 5,
											}}
										>
											<this.ColoredPreviewTextJSX colorings={this.state.colorings} /> {/* TO BE LOCALIZED */}
										</p>
									</div>
								</IonCard>
							</div>
							{this.state.ttsSettings && (
								<div className="settingsCard ttsSection">
									<p className="settingsDocumentViewingPreviewHeaderParagraph">
										<Trans>Sintesi vocale</Trans>
									</p>
									<IonCard className="ttsBox" mode="md">
										<IonCardContent>
											<IonList className="ttsList" lines="none">
												<div className="ttsItems">
													<div className="settingsDocumentViewingItemDivTablet">
														<p className={"settingsDocumentViewingParagraph"}>
															<Trans>Velocità di riproduzione</Trans>
														</p>
														<IonSelect
															id="playbackSpeedPicker"
															className="settingsTtsSelect"
															value={this.state.ttsSettings.speech_rate === 0.75 ? "slow" : this.state.ttsSettings.speech_rate === 1 ? "medium" : "fast"}
															interface="alert"
															onIonChange={(e) => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
																else {
																	if (e.detail.value === "") return;
																	if (this.state.userUuid) {
																		settingsServices
																			.setTtsSpeed(this.state.userUuid, e.detail.value, this.state.bearerToken)
																			.then((ttsSettings) => this.setState({ ttsSettings: ttsSettings }))
																			.catch((err) => {
																				console.error("[Settings] Error changing voice prosody rate", err);
																			});
																	}
																}
															}}
														>
															<IonSelectOption value="slow">
																<Trans>Lento</Trans>
															</IonSelectOption>{" "}
															{/* TO BE LOCALIZED */}
															<IonSelectOption value="medium">
																<Trans>Medio</Trans>
															</IonSelectOption>{" "}
															{/* TO BE LOCALIZED */}
															<IonSelectOption value="fast">
																<Trans>Veloce</Trans>
															</IonSelectOption>{" "}
															{/* TO BE LOCALIZED */}
														</IonSelect>
													</div>
												</div>
												<div className="ttsItems">
													<div className="settingsDocumentViewingItemDivTablet">
														<p className="settingsDocumentViewingParagraph">
															<Trans>Genere</Trans>
														</p>
														<IonSelect
															id="genderPicker"
															className="settingsTtsSelect"
															value={this.state.ttsSettings.speech_gender === "female" ? "female" : "male"}
															interface="alert"
															onIonChange={(e) => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
																else {
																	if (e.detail.value === "") return;
																	if (this.state.userUuid) {
																		settingsServices
																			.setVoiceType(this.state.userUuid, e.detail.value, this.state.bearerToken)
																			.then((ttsSettings) => this.setState({ ttsSettings: ttsSettings }))
																			.catch((err) => {
																				console.error("[Settings] Error changing voice gender", err);
																			});
																	}
																}
															}}
														>
															<IonSelectOption value="male">
																<Trans>Voce 1</Trans>
															</IonSelectOption>
															<IonSelectOption value="female">
																<Trans>Voce 2</Trans>
															</IonSelectOption>
														</IonSelect>
													</div>
												</div>
												<IonItem className="ttsItems">
													<div className="settingsDocumentViewingItemDiv-ttsDemo">
														<IonButton
															fill="clear"
															onClick={() => {
																let fromButton = true;
																if (this.state.paywallState) loadPaywall(fromButton);
																else this.playAudio();
															}}
														>
															<IonIcon className="settingVoicePreviewButtonIcon" icon={ear} />
															<Trans>Ascolta la voce</Trans> {/* TO BE LOCALIZED */}
														</IonButton>
													</div>
												</IonItem>
											</IonList>
										</IonCardContent>
									</IonCard>
								</div>
							)}
							<div className="settingsCard highlightSection">
								{/* <p className='settingsSectionParagraph'>
								<Trans>Evidenziazioni</Trans>
							</p> */}
								<div>
									<div className="settingsHighlightingsToggleDiv">
										<p className="settingsHighlightingsToggleParagraph">
											<Trans>Colorazione di lettere o parole</Trans>
										</p>
										<IonToggle
											className="highlightToggle"
											checked={this.state.isHighlightingActive}
											onClick={(e) => {
												let fromButton = true;
												if (this.state.paywallState) loadPaywall(fromButton);
												else {
													settingsServices.toggleHighlightings(this.state.userUuid!, !this.state.isHighlightingActive);
													this.setState({ isHighlightingActive: !this.state.isHighlightingActive });
												}
											}}
										></IonToggle>
									</div>
									<div className="settingsHighlightDiv">
										<IonItem className="settingsHighlightItem" hidden={!this.state.isHighlightingActive}>
											{/* <IonLabel
											className='settingsHighlightPlaceholder'
											hidden={this.state.highlightTargetText === '' ? false : true}
										>
											<Trans style={{ textOverflow: 'ellipsis' }}>Lettere da colorare</Trans> 
										</IonLabel> */}

											<IonInput
												label={
													i18n.language === "it"
														? "Lettere da colorare"
														: i18n.language === "en"
														? "Characters to colour"
														: i18n.language === "es"
														? "Letras a destacar"
														: i18n.language === "fr"
														? "Surlignez des lettres"
														: i18n.language === "de"
														? "Buchstaben färben"
														: i18n.language === "ca"
														? "Lletres per pintar"
														: i18n.language === "pt"
														? "Letras para colorir"
														: i18n.language === "cz"
														? "Písmena k vybarvení"
														: i18n.language === "nl"
														? "Letters om te kleuren"
														: ""
												}
												labelPlacement="floating"
												id="lettersToMarkInput"
												style={{ textOverflow: "ellipsis", color: this.state.pickedColor }}
												onFocus={() => this.handleFocusInput()}
												onKeyUp={(e) => {
													const target = e.target as HTMLInputElement; // Cast to HTMLInputElement
													const value = target.value; // Now you can access value
													this.setState({
														highlightTargetText: value ? value : "",
													});
												}}
												value={this.state.highlightTargetText}
											/>

											{/* <div
												slot='end'
												onClick={() => {
													this.setState({ showColorPicker: true })
												}}
												className='settingsColorDiv'
												style={{ background: this.state.pickedColor }}
											>
											</div> */}
											<span
												onClick={() => {
													this.setState({ isColorPickerOpen: true });
												}}
												className="colorPickerOpen"
											></span>
											<IonButton
												slot="end"
												className="settingsSaveHighlightingButton"
												disabled={this.state.highlightTargetText === ""}
												onClick={() => {
													let fromButton = true;
													if (this.state.paywallState) loadPaywall(fromButton);
													else {
														if (this.state.userUuid) {
															console.log(this.state.colorings);
															const existingElement = this.state.colorings.find((element) => element.text_pattern === this.state.highlightTargetText);

															if (existingElement) {
																if (existingElement.color !== this.state.pickedColor) {
																	// Case 1: Update the color if text_pattern matches but the color is different
																	settingsServices
																		.updateTextColouring(
																			this.state.userUuid,
																			existingElement.id,
																			this.state.highlightTargetText,
																			this.state.pickedColor,
																			this.state.bearerToken
																		)
																		.then((highlight) => {
																			const updatedColorings = this.state.colorings.map((item) =>
																				item.id === existingElement.id ? { ...item, color: this.state.pickedColor } : item
																			);
																			console.log(updatedColorings);
																			this.setState({
																				colorings: updatedColorings,
																				highlightTargetText: "",
																			});
																		})
																		.catch((err) => {
																			console.error("[Settings] error updating highlighting:", err);
																		});
																} else {
																	// Case 3: Alert if both text_pattern and color match
																	alert("Lettera/parola già inserita con lo stesso colore");
																}
															} else {
																// Case 2: Add new coloring if no element with the same text_pattern is found
																settingsServices
																	.addTextColouring(this.state.userUuid, this.state.highlightTargetText, this.state.pickedColor, this.state.bearerToken)
																	.then((highlight) => {
																		const newColorings = [...this.state.colorings, highlight];
																		console.log(newColorings);
																		this.setState({
																			colorings: newColorings,
																			highlightTargetText: "",
																		});
																	})
																	.catch((err) => {
																		console.error("[Settings] error adding highlighting:", err);
																	});
															}
														}
													}
												}}
											>
												<Trans>Salva</Trans>
											</IonButton>
										</IonItem>
									</div>
									{/* <div hidden={!this.state.isHighlightingActive} className='settingsColorPickerDiv'>
									<ChromePicker color={this.state.pickedColor} onChange={(e) => this.setState({ pickedColor: e.hex })} disableAlpha />
								</div> */}
									<IonList className="settingsHighlightList" hidden={!this.state.isHighlightingActive} lines="none">
										{this.state.colorings.map((coloring) => {
											return (
												<IonItem key={coloring.id} className="settingsHighlightItem">
													<IonGrid className="settingsHighlightItemGrid">
														<IonRow style={{ color: coloring.color }} className="settingsHighlightItemGridRow">
															<b>{coloring.text_pattern}</b>
														</IonRow>

														<IonRow className="settingsHighlightItemGridColorRow">
															<div className="settingsColorDiv" style={{ background: coloring.color }}></div>
														</IonRow>

														<IonRow className="settingsHighlightItemGridRemoveRow">
															<IonButton
																fill="clear"
																color="danger"
																shape="round"
																onClick={() => {
																	if (this.state.userUuid) {
																		// settingsServices
																		// 	.deleteHighlighting(this.state.userUuid, coloring.id)
																		// 	.then(() => {
																		// 		this.setState({
																		// 			highlightings: this.state.highlightings.filter((highlightPref) => highlightPref.uuid !== coloring.user_id),
																		// 		});
																		// 	})
																		// 	.catch((err) => {
																		// 		console.error("[Settings] error deleting highlighting id:", coloring.id, "error:", err);
																		// 	});
																		settingsServices
																			.deleteTextColouring(this.state.userUuid, coloring.id, this.state.bearerToken)
																			.then(() => {
																				this.setState({
																					colorings: this.state.colorings.filter((prevColoring) => prevColoring.id !== coloring.id),
																				});
																			})
																			.catch((err) => {
																				console.error("[Settings] error deleting highlighting id:", coloring.id, "error:", err);
																			});
																	}
																}}
															>
																<IonIcon icon={removeCircleOutline} />
															</IonButton>
														</IonRow>
													</IonGrid>
												</IonItem>
											);
										})}
									</IonList>
								</div>
							</div>

							<div className="colorChange">
								<p className="settingsDocumentViewingPreviewHeaderParagraph">
									<Trans>Cambia Palette colori</Trans>
								</p>
								<IonList className="paletteList">
									{/* change color theme */}
									<IonItem className="paletteItems">
										<IonSelect
											className="paletteItem"
											label="Palette"
											mode="md"
											interface="popover"
											placeholder={this.state.preferredPalette}
											onIonChange={(e) => {
												let fromButton = true;
												if (this.state.paywallState) loadPaywall(fromButton);
												else {
													setTheme(e.detail.value);
													if (this.state.userUuid) {
														console.log(this.state.userUuid);
														// update(ref(database, `u/${this.state.userUuid}`), {
														// 	t: e.detail.value,
														// }).catch((err) => {
														// 	console.error("[Profile] error updating user preferred palette:", err);
														// });
														settingsServices.setPreferredTheme(this.state.userUuid, e.detail.value, this.state.bearerToken);
													}
												}
											}}
										>
											{themes.map((theme, i = 0) => (
												<IonSelectOption value={theme}>{theme}</IonSelectOption>
											))}
										</IonSelect>
									</IonItem>
								</IonList>
							</div>
							{/* <div className="settingsLicensesButtonDiv licenseSection">
						<IonButton
							color="medium"
							onClick={() => {
								this.props.history.push('/legal/licenses');
							}}
							fill="clear"
							class="settingsLicensesButton"
						>
							<Trans>Licenze</Trans>
						</IonButton>
					</div> */}
						</IonGrid>
					</>
				)}
				{isMobile && <MenuTabBar profile={undefined} settings={settingsIcon} home={undefined} />}

				<IonModal className="colorPickerModal" isOpen={this.state.isColorPickerOpen} onDidDismiss={() => this.setState({ isColorPickerOpen: false })}>
					<div className="colorPickerBackIcon">
						<IonIcon
							className="colorpickerBack"
							onClick={() => {
								this.setState({ isColorPickerOpen: false });
							}}
							icon={chevronBack}
							style={{ cursor: "pointer" }}
						></IonIcon>
						<IonTitle className="colorPickerTitle">
							<Trans>Cambia colore</Trans>
						</IonTitle>
					</div>

					<IonContent className="colorPickerContainer">
						<div className="color-preview">
							<div className="color-preview-inner" style={{ backgroundColor: this.state.previewColor }}>
								{hslToHex(this.state.hue, this.state.saturation, this.state.brightness)}
							</div>
						</div>
						<IonGrid>
							<IonRow>
								<IonCol>
									<IonLabel className="colorPickerSlidersTxt">
										<Trans>Hue</Trans>
									</IonLabel>

									<IonRange
										className="hueRangeSlider"
										min={0}
										max={360}
										step={1}
										value={this.state.hue}
										onIonChange={(e) =>
											this.setState({ hue: e.detail.value as number }, () => {
												this.setState({ previewColor: updateColor(this.state.hue, this.state.saturation, this.state.brightness) });
											})
										}
										onIonBlur={() => {
											this.setState({ previewColor: updateColor(this.state.hue, this.state.saturation, this.state.brightness) });
										}}
										onMouseUp={() => {
											this.setState({ recentColors: saveColor(this.state.previewColor, this.state.recentColors) });
										}}
									></IonRange>
								</IonCol>
							</IonRow>
							<IonRow>
								<IonCol>
									<IonLabel className="colorPickerSlidersTxt">
										<Trans>Saturation</Trans>
									</IonLabel>

									<IonRange
										className="saturationRangeSlider"
										min={0}
										max={100}
										step={1}
										value={this.state.saturation}
										onIonChange={(e) =>
											this.setState({ saturation: e.detail.value as number }, () => {
												this.setState({ previewColor: updateColor(this.state.hue, this.state.saturation, this.state.brightness) });
											})
										}
										onIonBlur={() => {
											this.setState({ previewColor: updateColor(this.state.hue, this.state.saturation, this.state.brightness) });
										}}
										onMouseUp={() => {
											this.setState({ recentColors: saveColor(this.state.previewColor, this.state.recentColors) });
										}}
									></IonRange>
								</IonCol>
							</IonRow>
							<IonRow>
								<IonCol>
									<IonLabel className="colorPickerSlidersTxt">
										<Trans>Brightness</Trans>
									</IonLabel>

									<IonRange
										className="brightnessRangeSlider"
										min={0}
										max={100}
										step={1}
										value={this.state.brightness}
										onIonChange={(e) =>
											this.setState({ brightness: e.detail.value as number }, () => {
												this.setState({ previewColor: updateColor(this.state.hue, this.state.saturation, this.state.brightness) });
											})
										}
										onIonBlur={() => {
											this.setState({ previewColor: updateColor(this.state.hue, this.state.saturation, this.state.brightness) });
										}}
										onMouseUp={() => {
											this.setState({ recentColors: saveColor(this.state.previewColor, this.state.recentColors) });
										}}
									></IonRange>
								</IonCol>
							</IonRow>
						</IonGrid>

						<IonItemDivider className="colorPickerText">
							<Trans>Campioni</Trans>
						</IonItemDivider>
						<IonList className="colorSampleList">
							{this.state.savedColors.slice(-6).map((color, index) => (
								<div
									className="color-box"
									style={{ backgroundColor: color }}
									onClick={() => {
										this.setState({ pickedColor: color, isColorPickerOpen: false });
									}}
								></div>
							))}
						</IonList>
						<IonItemDivider className="colorPickerText">
							<Trans>Recenti</Trans>
						</IonItemDivider>
						<IonList className="colorSampleList">
							{this.state.recentColors.slice(-6).map((color, index) => (
								<div
									className="color-box"
									style={{ backgroundColor: color }}
									onClick={() => {
										this.setState({ pickedColor: color, isColorPickerOpen: false });
									}}
								></div>
							))}
						</IonList>
						<div className="colorPickerSaveButtonContainer">
							<IonButton
								className="colorPickerSaveButton"
								onClick={() => {
									this.setState({ pickedColor: this.state.previewColor, isColorPickerOpen: false });
									this.setState({ savedColors: saveColor(this.state.previewColor, this.state.savedColors) }, () => {
										if (this.state.userUuid) {
											console.log(this.state.userUuid);
											update(ref(database, `u/${this.state.userUuid}`), {
												cp: this.state.savedColors.slice(-6),
											}).catch((err) => {
												console.error("[Profile] error updating user preferred palette:", err);
											});
										}
									});
								}}
							>
								<Trans>Salva</Trans>
							</IonButton>
						</div>
					</IonContent>
				</IonModal>
			</IonPage>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		orgData: state.user.organization,
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
